<template>
  <div style="width: 100%">
    <slider
      :value="value"
      :data-values="['bypass', 'mfa', 'deny']"
      @input="updateValue"
      :class="disabled? `disabled-policy no-hover ${policySliderClass}`: policySliderClass"
      :disabled="disabled"
      ref="policy_slider"
    ></slider>
  </div>
</template>

<script>
import Slider from "@/components/Slider";

export default {
  name: "PolicySlider",
  components: { Slider },
  props: ["value", "disabled"],
  data() {
    return {
      colorValue: ""
    };
  },
  computed: {
    policySliderClass: function() {
      switch (this.colorValue) {
        case "deny":
          return "deny-policy";
        case "bypass":
          return "allow-policy";
        case "mfa":
          return "mfa-policy";
        default:
          return "";
      }
    }
  },
  methods: {
    updateValue: function(event) {
      this.colorValue = event;
      this.$emit("input", event);
    }
  },
  updated() {
    this.colorValue = this.value;
  },
  mounted() {
    this.colorValue = this.value;
  }
};
</script>

<style lang="scss">
@import "../assets/scss/md/colors";
$disabled-color: #b3b3b3;
$deny-color: #959595;
$deny-hover-color: #6f6f6f;
$mfa-color: $green;
$mfa-hover-color: $green-700;
$allow-color: $orange;
$allow-hover-color: $orange-700;
.deny-policy {
  .vue-slider-dot-tooltip-inner {
    border-color: $deny-color;
    background-color: $deny-color;
  }

  .vue-slider-dot-handle {
    border-color: $deny-color;
  }

  .vue-slider-process {
    background-color: $deny-color;
  }

  .vue-slider:hover .vue-slider-process {
    background-color: $deny-hover-color;
  }

  vue-slider:hover .vue-slider-dot-handle:hover {
    border-color: $deny-hover-color;
  }
}
.mfa-policy {
  .vue-slider-dot-tooltip-inner {
    border-color: $mfa-color;
    background-color: $mfa-color;
  }

  .vue-slider-dot-handle {
    border-color: $mfa-color;
  }

  .vue-slider-process {
    background-color: $mfa-color;
  }

  .vue-slider:hover .vue-slider-process {
    background-color: $mfa-hover-color;
  }

  .vue-slider:hover .vue-slider-dot-handle:hover {
    border-color: $mfa-hover-color;
  }
}
.allow-policy {
  .vue-slider-dot-tooltip-inner {
    border-color: $allow-color;
    background-color: $allow-color;
  }

  .vue-slider-dot-handle {
    border-color: $allow-color;
  }

  .vue-slider-process {
    background-color: $allow-color;
  }

  .vue-slider:hover .vue-slider-process {
    background-color: $allow-hover-color;
  }

  .vue-slider:hover .vue-slider-dot-handle:hover {
    border-color: $allow-hover-color;
  }
}
.disabled-policy {
  opacity: 0.4;
}
.no-hover {
  pointer-events: none;
}
</style>
